// src/components/StepNavigationBar.js
import React from "react";
import { Box, Stack, Button } from "@mui/material";

/**
 * StepNavigationBar
 * Props:
 *  - activeStep: number
 *  - canGoBack: boolean
 *  - onBack: () => void
 *  - onNext: () => void
 *  - saveHandler: (() => void | Promise<void>) | null
 *  - saveLabel: string | null
 *  - isSaveDisabled: boolean
 *  - isNextDisabled: boolean
 */
export default function StepNavigationBar({
  activeStep,
  canGoBack,
  onBack,
  onNext,
  saveHandler,
  saveLabel,
  isSaveDisabled,
  isNextDisabled,
  nextLabel = "Next",
}) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
    >
      <Button disabled={!canGoBack} onClick={onBack}>
        Back
      </Button>

      <Box display="flex" alignItems="center" gap={1}>
        {saveHandler && saveLabel && (
          <Button
            variant="contained"
            onClick={saveHandler}
            disabled={isSaveDisabled}
          >
            {saveLabel}
          </Button>
        )}

        <Button
          variant="outlined"
          onClick={onNext}
          disabled={isNextDisabled}
        >
          {nextLabel}
        </Button>
      </Box>
    </Stack>
  );
}
